import React from "react";
import { Input } from "reactstrap";

const FootprintInputRadio = ({
  className,
  key,
  id,
  name,
  label,
  onClick = () => {},
  value,
}) => {
  return (
    <Input
      className={className}
      type="radio"
      name={name}
      label={label}
      value={value}
      style={{ color: "black" }}
      key={key}
      id={id}
      onClick={(event) => {
        if (onClick) {
          onClick(event.target.value);
        }
      }}
      required
    />
  );
};

export default FootprintInputRadio;
